/**
 * Ключи запросов. Собраны в одном месте, чтобы инвалидация после изменения
 * попадала ровно в те запросы, которые устарели: `['stores']` накрывает и
 * список, и карточки, а `['stores', id]` — только одну карточку.
 */
export const keys = {
  dashboard: (from: string, to: string, storeId: number) =>
    ['dashboard', from, to, storeId] as const,

  stores: ['stores'] as const,
  store: (id: number) => ['stores', id] as const,

  roles: ['roles'] as const,
  role: (id: number) => ['roles', id] as const,

  staff: ['staff'] as const,
  staffMember: (id: number) => ['staff', id] as const,
  staffSessions: (id: number) => ['staff', id, 'sessions'] as const,

  categories: ['categories'] as const,
  category: (id: number) => ['categories', id] as const,

  stories: ['stories'] as const,

  news: (query: Record<string, unknown>) => ['news', query] as const,
  newsAll: ['news'] as const,

  reviews: (query: Record<string, unknown>) => ['reviews', query] as const,

  products: (query: Record<string, unknown>) => ['products', query] as const,
  product: (id: number) => ['products', id] as const,
  /** Числа у пунктов фильтров; под префиксом `products` — правка товара их обновляет. */
  productCounts: ['products', 'counts'] as const,
  productStock: (id: number) => ['products', id, 'stock'] as const,
  productSales: (id: number, from: string, to: string) =>
    ['products', id, 'sales', from, to] as const,

  customers: (query: Record<string, unknown>) => ['customers', query] as const,
  customer: (id: number) => ['customers', id] as const,
  customerAddresses: (id: number) => ['customers', id, 'addresses'] as const,

  orders: (query: Record<string, unknown>) => ['orders', query] as const,
  order: (id: number) => ['orders', id] as const,
  board: (storeId: number, ship: string) => ['board', storeId, ship] as const,

  integrations: ['integrations'] as const,
  integrationLog: (key: string) => ['integrations', key, 'log'] as const,
  fom: ['integrations', 'fom'] as const,
  paymentChannels: ['integrations', 'payment', 'channels'] as const,
  mapKeys: ['integrations', 'geo', 'map-keys'] as const,
  // Поиск места геокодером Яндекса — чужой сервис, не наш API.
  geoSearch: (query: string) => ['geo', 'search', query] as const,

  // Уведомления сотрудника: `['notifications']` накрывает и список, и счётчик —
  // так их обновляет одно живое событие.
  notificationsAll: ['notifications'] as const,
  notifications: (query: Record<string, unknown>) => ['notifications', 'list', query] as const,
  notificationsList: ['notifications', 'list'] as const,
  notificationsUnread: ['notifications', 'unread'] as const,

  settings: ['settings'] as const,
  page: (slug: string) => ['pages', slug] as const,
} as const
